<template>
    <FormSection :application-id="application">
        <template #content>
            <div class="p-2 px-4">
                <div class="col-12 row">
                    <div class="form-group col-8">
                        <label for="vaccine-name"> Vaccine Name <span class="text-danger">*</span> </label>
                        <TypeaheadInput
                            :getData="getVaccineList"
                            :value="selectedVaccine"
                            v-on:valueChanged="selectedVaccineChanged"
                            placeholder="Enter Vaccine Name"
                            :disabled="isViewOnly || isEdit"
                            v-on:blurredInput="v$.immunization.CvxCode.$touch()"
                        >
                        </TypeaheadInput>
                        <span v-if="v$.immunization.CvxCode.$error" class="field-invalid"
                            >Vaccine Name is required.</span
                        >
                    </div>
                    <div class="form-group col-4">
                        <label for="lot-number">Lot Number</label>
                        <input
                            class="form-control"
                            maxlength="50"
                            type="text"
                            placeholder="Enter Lot Number"
                            v-model="immunization.LotNumber"
                            :disabled="isViewOnly"
                        />
                    </div>
                </div>
                <div class="col-12 row">
                    <div class="form-group col-4">
                        <label for="manufacturer">Manufacturer</label>
                        <input
                            class="form-control"
                            type="text"
                            placeholder="Enter Manufacturer"
                            v-model="immunization.Manufacturer"
                            disabled
                        />
                    </div>
                    <div class="form-group col-4">
                        <label for="date-of-vaccination">
                            Date of Vaccine
                            <span
                                class="text-danger"
                                v-if="immunizationStatusEnumMap.checkEnumValue('Completed', immunization.Status)"
                                >*</span
                            >
                        </label>
                        <DatePicker :options="datePickerOptions" :getDate="handleDateChange">
                            <div class="input-group date datepickerInput">
                                <input
                                    type="text"
                                    name="date-of-vaccination"
                                    class="form-control"
                                    :value="formatDateInput(immunization.DateOfVaccination)"
                                    placeholder="Select Date"
                                    autocomplete="off"
                                    :disabled="isViewOnly"
                                    @change="handleDateInputChange"
                                    @blur="v$.immunization.DateOfVaccination.$touch()"
                                />
                                <div class="input-group-addon input-group-append">
                                    <div class="input-group-text">
                                        <i class="fa fa-calendar"></i>
                                    </div>
                                </div>
                                <span v-if="v$.immunization.DateOfVaccination.$error" class="field-invalid"
                                    >Date Of Vaccination is required.</span
                                >
                            </div>
                        </DatePicker>
                    </div>

                    <div class="form-group col-4">
                        <label for="administered-by">Administered By</label>
                        <input
                            class="form-control"
                            maxlength="100"
                            type="text"
                            placeholder="Enter Who Administered the Vaccine"
                            v-model="immunization.AdministeredBy"
                            :disabled="isViewOnly"
                        />
                    </div>
                </div>
                <div class="col-12 row">
                    <div class="form-group col-4">
                        <label for="status">Type of Record <span class="text-danger">*</span></label>
                        <select
                            class="form-select"
                            v-model="immunization.TypeOfRecord"
                            :disabled="isViewOnly"
                            @blur="v$.immunization.TypeOfRecord.$touch()"
                        >
                            <option :value="null">Select Type of Record</option>
                            <option v-for="type of typeOfRecordEnum" :value="type.value">{{ type.name }}</option>
                        </select>
                        <span v-if="v$.immunization.TypeOfRecord.$error" class="field-invalid"
                            >Type Of Record is required.</span
                        >
                    </div>
                    <div class="form-group col-4">
                        <label for="status">Immunization Status <span class="text-danger">*</span></label>
                        <select
                            class="form-select"
                            v-model="immunization.Status"
                            :disabled="isViewOnly"
                            @blur="v$.immunization.Status.$touch()"
                        >
                            <option :value="null">Select Immunization Status</option>
                            <option v-for="type of immunizationStatusEnum" :value="type.value">
                                {{ type.name }}
                            </option>
                        </select>
                        <span v-if="v$.immunization.Status.$error" class="field-invalid">Status is required.</span>
                    </div>
                </div>
                <div class="col-12 row">
                    <div class="form-group col-12">
                        <label for="comments">Comments</label>
                        <textarea
                            class="form-control"
                            name="comments"
                            v-model="immunization.Comments"
                            placeholder="Enter Comments"
                            :disabled="isViewOnly"
                            maxlength="200"
                        ></textarea>
                    </div>
                </div>
            </div>
        </template>
    </FormSection>
</template>

<script src="./VaccineRecordForm.ts"></script>
